import React, { useEffect } from 'react'
import styled from '@emotion/native'
import { USER_STATUS } from 'conkis-core'
import { VIEW } from '~/const'
import { changeView } from '~/store'
import { useGlobalState } from '~/store/hooks'

// Views
import Home from '~/components/views/Home'
import Profile from '~/components/views/Profile'
import Cards from '~/components/views/Cards'
import Shop from '~/components/views/Shop'
import Leaderboard from '~/components/views/Leaderboard'
import LiveGames from '~/components/views/LiveGames'
import Play from '~/components/views/Play'
import Game from '~/components/views/Game/Game'

const VIEWS = {
    [VIEW.HOME]: <Home />,
    [VIEW.PROFILE]: <Profile />,
    [VIEW.CARDS]: <Cards />,
    [VIEW.SHOP]: <Shop />,
    [VIEW.LEADERBOARD]: <Leaderboard />,
    [VIEW.LIVEGAMES]: <LiveGames />,
    [VIEW.PLAY]: <Play />,
    [VIEW.GAME]: <Game />,
}

export default function View() {
    const [{ view, user }] = useGlobalState(
        'view',
        'user',
        'user.status',
        'user.status.type'
    )

    useEffect(() => {
        if (user.status.type === USER_STATUS.PLAYING) {
            const { game_id } = user.status
            changeView(VIEW.GAME, { game_id: game_id })
        }
    }, [user.status.type])

    return (
        <Container>
            <Content>{VIEWS[view]}</Content>
        </Container>
    )
}

const Container = styled.View`
    flex: 1;
`

const Content = styled.View`
    width: 100%;
    height: 100%;
`
